const SplitPhoneVT = (phone: string) => {
  let result = {
    check: true,
    msg: ''
  }
  if (!phone) {
    return {
      check: false,
      msg: '请输入'
    }
  }
  const _phoneMti = phone?.split(',') // +86的时候需要考虑到多个情况
  for(let i = 0; i < _phoneMti.length; i++) {
    if (!/^[1][2-9][0-9]{9}$/.test(_phoneMti[i])) {
      result = {
        check: false,
        msg: '请输入正确的手机号'
      }
      break
    }
  }
  return result
}
const ValidatorRule = ({
  value,
  type,
  required,
  msg
}: {
  value: string
  type: string
  required?: boolean
  msg: string
}) => {
  if (!!required && !value) {
    return {
      check: false,
      msg
    }
  }
  if (type === '‌i18n‌Config') { // 国际化的配置，需要区域
    let initValue = []
    if (value?.indexOf('-') > -1) {
      initValue = value.split('-')
    } else {
      initValue = ['', value]
    }
    let [prefix, phone] = initValue
    if (!required && !phone) { // 不必填直接校验通过就行
      return {
        check: true,
        msg: ''
      }
    }
    if (prefix && prefix !== '+86' && phone) {
      return {
        check: true,
        msg: ''
      }
    }
    return SplitPhoneVT(phone)
  }
  if (!required && !value) { // 不必填直接校验通过就行
    return {
      check: true,
      msg: ''
    }
  }
  return SplitPhoneVT(value)
}

const SubmitData = ({
  value,
  type,
}: {
  value: string
  type: string
}) => {
  if (type === '‌i18n‌Config') { // 国际化的配置
    let initValue = []
    if (value?.indexOf('-') > -1) {
      initValue = value.split('-')
    } else {
      initValue = ['', value]
    }
    let [prefix, phone] = initValue
    const _list = []
    const _phoneMti = phone?.split(',') // +86的时候需要考虑到多个情况
    for(let i = 0; i < _phoneMti.length; i++) {
      _list.push(`${prefix || '+86'}-${_phoneMti[i]}`)
    }
    return _list?.join(',')
  }
  return value
}
export default {
  ValidatorRule,
  SubmitData
}